
import React, { useState } from 'react';
import { PatrolObservationsList } from '@/components/patrol-observations/PatrolObservationsList';
import { ReportsFilters } from '@/components/reports/ReportsFilters';

interface PatrolObservationsViewProps {
  teamId: string;
}

export const PatrolObservationsView = ({ teamId }: PatrolObservationsViewProps) => {
  const [selectedTeam, setSelectedTeam] = useState<string | undefined>(teamId);
  const [selectedDate, setSelectedDate] = useState<Date | undefined>();

  const handleReset = () => {
    setSelectedTeam(teamId);
    setSelectedDate(undefined);
  };

  const dateFilter = selectedDate ? {
    start: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0),
    end: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 23, 59, 59)
  } : undefined;

  return (
    <div className="p-6 space-y-6">
      <ReportsFilters
        selectedTeam={selectedTeam}
        onTeamChange={setSelectedTeam}
        selectedDate={selectedDate}
        onDateChange={setSelectedDate}
        onReset={handleReset}
        showTeamFilter={false} // Hide team filter since we're already in a team context
      />
      
      <PatrolObservationsList 
        teamId={selectedTeam || teamId} 
        dateFilter={dateFilter}
      />
    </div>
  );
};
